export enum AjustePontoSituacao {
    Pendente = 'Pendente',
    Aprovado = 'Aprovado',
    Recusado = 'Recusado'
}

export interface IAjustePontoTrabalhador {
    trabalhador: string;
    status: any;
    tipo: number;
    subtipo: any;
    codigo: string;
    nome: string;
    email: any;
    identificacaonasajon: string;
    salariofixo: string;
    cpf: any;
    dataadmissao: string;
    datarescisao: any;
    datareintegracaoretorno: any;
    datafimcontrato: any;
    datafimmarcacaoponto: any;
    datavencimentoatestadomedico: string;
    lotacao: string;
    identidadecorporativa: any;
    lastupdate: string;
    agenciaguid: any;
    numerocontasalario: any;
    numerocontasalariodv: any;
    categoriatrabalhador: string;
    salarioliquidodiario: any;
    motivocontratacaotemporaria: any;
    tipoinclusaotemporaria: any;
    cpftrabalhadorsubstituido: any;
}

export interface IAjustePontoEmpresa {
    empresa: string;
    codigo: string;
    razaosocial: string;
    raizcnpj: any;
    ordemcnpj: any;
    descricao: any;
    nomecontato: any;
    lastupdate: string;
    usapontoweb: boolean;
}

export interface IAjustePontoEstabelecimento {
    estabelecimento: string;
    codigo: string;
    nomefantasia: string;
    raizcnpj: string;
    ordemcnpj: string;
    tipologradouro: any;
    logradouro: any;
    numero: any;
    complemento: any;
    bairro: any;
    cidade: any;
}

export interface IAjustePontoDepartamento {
    departamento: string;
    codigo: string;
    estabelecimento: string;
    nome: string;
}

export interface IAjustePontoLotacao {
    lotacao: string;
    codigo: string;
    nome: string;
    tipo: number;
    desabilitado: boolean;
    bancohoras: boolean;
    empresa: string;
    estabelecimento: string;
    tomador: any;
}

export interface IAjustePontoGrupo {
    grupo: string;
    nome: string;
}

export interface IAjustePontoGrupoEmpresarial {
    grupoempresarial: string;
    codigo: string;
    descricao: string;
    escopoworkflowweb: any;
}

export interface IAjustePonto {
    gestaoponto: string;
    origemid: string;
    tenant: number;
    origem: string;
    tipo: string;
    tipo_exibicao?: string;
    tipocodigo: number;
    status: string;
    statuscodigo: number;
    datareferencia: string;
    dataajustada: string;
    motivo: string;
    justificativa: string;
    detalhes: Record<string, any>;
    colaborador_fotooriginal?: string | null;
    full_count?: number;
    trabalhador: IAjustePontoTrabalhador;
    empresa: IAjustePontoEmpresa;
    grupoempresarial: IAjustePontoGrupoEmpresarial;
    estabelecimento: IAjustePontoEstabelecimento;
    departamento: IAjustePontoDepartamento;
    lotacao: IAjustePontoLotacao;
    grupo: IAjustePontoGrupo;
    // campos decorados pelo controller
    id?: string;
    trabalhadorDisplay?: string;
    colaboradorFotoUrl?: string;
    matricula?: string;
    dataAjustadaDisplay?: string;
    horarioDisplay?: string;
    detalhesDisplay?: string;
    detalhesMotivo?: string;
    temAnexo?: boolean;
    historicoStatusExibicao?: string;
    horarioLabel?: string;
    horarioAntigo?: string;
    horarioNovo?: string;
    situacaoLabel?: string;
    situacaoClasse?: string;
    disableCheckbox?: boolean;
    rowcustomclass?: string;
}
